import React from 'react';
import { ThemeProvider } from 'styled-components';

import { defaultTheme } from './defaultTheme';

export const BuddyThemeProvider: React.FC<{ children: JSX.Element }> = ({ children }) => (
  <ThemeProvider theme={defaultTheme}>{children}</ThemeProvider>
);
